// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB_yklVsN52Iz04rQLHWR6TXKDxSaNNRW0",
  authDomain: "todo-firebase-f7927.firebaseapp.com",
  projectId: "todo-firebase-f7927",
  storageBucket: "todo-firebase-f7927.appspot.com",
  messagingSenderId: "716651863186",
  appId: "1:716651863186:web:ffcba22fa8a96bd0cc1a4b",
  measurementId: "G-2F1933G780",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app);

const todoCollection = collection(db, "todos");

// Initialize Firebase Authentication and get a reference to the service

export default todoCollection;
export { db };
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
